import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class FloorIndexRequiredError extends CodedError {
  static get errorName() {
    return errorCodeTypes.floorIndexRequiredError.code;
  }

  constructor(message = errorCodeTypes.floorIndexRequiredError.message) {
    super(message);
    this.code = errorCodeTypes.floorIndexRequiredError.code;
    this.message = `${message} ${errorCodeTypes.floorIndexRequiredError.code}`;
    this.name = errorCodeTypes.floorIndexRequiredError.name;
  }
}
